import React from 'react'

const GameProducer = ({ image, title, link, maxHeight }) => (
  <div className='gameproducer__container '>
    {/*<div className='gameproducer__box--image' style={{ background: `url(${(image)}) no-repeat`}} >*/}
    <div className='gameproducer__box--image'>
      <img src={image} className='heightBigger' />
    </div>
    {/*<div className='gameproducer__box--title'>*/}
    {/*  <p>{title}</p>*/}
    {/*</div>*/}
  </div>
)

export default GameProducer
